import { ApiHttpError } from '@/shared/api/client';
import { ZodError } from 'zod';

export class SegmentPreviewMismatch extends Error {
  constructor() {
    super('segment_preview_mismatch');
    this.name = 'SegmentPreviewMismatch';
  }
}

export function describeSegmentSubmitError(error: unknown): string {
  if (error instanceof SegmentPreviewMismatch) {
    return "preview mismatch: the server's copy plan no longer matches this asset's video-track catalog or the marked window";
  }
  if (error instanceof ApiHttpError) {
    return `server rejected the request (HTTP ${error.status}): ${error.message}`;
  }
  if (error instanceof ZodError) {
    const first = error.issues[0];
    return `unexpected server response shape (${error.issues.length} issue(s); first at "${first?.path.join('.')}": ${first?.message})`;
  }
  return error instanceof Error ? error.message : String(error);
}
